var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main",class:{scrollable: !_vm.isFooterVisible}},[_c('kion-header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.isFooterVisible)?_c('kion-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }